import React from 'react';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import ShovelVault from '../../../CommonComponents/OPL/illustrations/shovel-vault.svg';

export const WorkflowAccountsHeader = () => {
  return (
    <>
      <ShovelVault width="298" style={{ margin: '0 auto', display: 'block' }} />

      <Text as="p" fontSize="h4" fontWeight={600} mt="40" mb="8">
        Let&apos;s talk about your current accounts and assets.
      </Text>

      <Text as="p" fontWeight={500} color="neutral.500">
        Now that we&apos;ve gotten to know a little more about you we need to learn more about your
        current financial accounts, investments, assets, and insurance to get the full picture of
        your financial situation.
      </Text>
    </>
  );
};
